import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`We don't want anyone under 18 using 69work.com. If that happens by accident, we delete everything we know about them as soon as we find out.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      